import { c as _c } from "react/compiler-runtime";
import type { SignalSeverity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useRiskSignalSeverityText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.riskSignals.severity"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = severity => {
      if (severity === "info") {
        return t(_temp);
      }
      if (severity === "low") {
        return t(_temp2);
      }
      if (severity === "medium") {
        return t(_temp3);
      }
      if (severity === "high") {
        return t(_temp4);
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useRiskSignalSeverityText;
function _temp($) {
  return $.info;
}
function _temp2($_0) {
  return $_0.low;
}
function _temp3($_1) {
  return $_1.medium;
}
function _temp4($_2) {
  return $_2.high;
}